<template>
    <div class="page-class">
        <div class="page-wrapper">
            <div id="getfriend_content"
                class="page-content page-container">
                 <div class="content">
                    <FriendGetFriend></FriendGetFriend>
                    <div class="text-center text-stroke-white text-small mt-3" :text="lbl.get_friend.get_friend_welcome">{{lbl.get_friend.get_friend_welcome}}</div>
                    <div class="text-center text-stroke-white text-small mb-3" :text="lbl.get_friend.get_friend_welcome2">{{lbl.get_friend.get_friend_welcome2}}</div>

                    <div class="text-center text-stroke-green text-medium text-white" :text="lbl.get_friend.get_friend_register">{{lbl.get_friend.get_friend_register}}</div>
                    <div class="text-center text-stroke-green text-medium text-white " :text="lbl.get_friend.get_friend_point">{{lbl.get_friend.get_friend_point}}</div>

                    <div id="getfriend_block">
                        <div id="getfriend_block_wrapper">
                            <img id="getfriend_block_img" class="img-fluid" src="../../../assets/bg/bg-getfriend-group.svg" />
                        </div>
                    </div>
                </div>
                <div class="btn-block">
                        <div id="getfriend_btn" class="btn-wrapper btn-sm">
                                <div class="btn-txt"
                                    @click="clickInvite()">{{lbl.get_friend.get_friend_register_btn}}</div>
                        </div>
                </div>
            </div>
        </div>

        <ModalMaster :controller="modalController" :theme="userType" />
    </div>
</template>
<script>
//helper
import LineFunction from '@/helper/facede/LineFunction.js';
//mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import FriendGetFriend from '../component/friendgetfriend/FriendGetFriend.vue';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";


export default {
    name: 'GetFriend',
    mixins: [ErrorApiMixin, LocaleMixin],
    components: {
        ModalMaster,
        FriendGetFriend
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            isLoading: false,
            profileImg: '',
            refcode: '',

            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),
        };
    },
    created: function () {
        this.refcode = this.$route.params.refcode;
        this.initUserInfo();
    },
    methods: {
        //event
        clickBack: function () {
            let line = new LineFunction();
            let liffId = line.getLiffId();
            line.init(liffId).then(() => {
                line.closeWindow();
            });
        },
        clickInvite: function () {
            this.$router.replace({path: '/register/line', query: {getfriendRefcode: this.refcode}});
        },
        redirectToHome:function(){
            this.$router.replace({path:"/"})
        },
        initUserInfo: function () {
            let line = new LineFunction();
            line.getProfile().then((profile) => {
                console.log('pro',profile)
                const isThereKey = !!Object.keys(profile).length
                if(isThereKey){
                    this.redirectToHome()
                    return;
                }
                this.setUserInfo(profile);
            }).catch((e) => {
                console.log(e);
                this.initLine();
            });
        },
        initLine: function () {
            let line = new LineFunction();
            let liffId = line.getLiffId();
            line.init(liffId).then(() => {
                return line.getProfile();
            }).then((profile) => {
                console.log('pro',profile)
                const isThereKey = !!Object.keys(profile).length
                if(isThereKey){
                    this.redirectToHome()
                    return;
                }
                this.setUserInfo(profile);
            }).catch((e) => {
                console.log(e);
            });
        },
        setUserInfo: function (lineProfile) {
            this.profileImg = lineProfile.pictureUrl;
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '../style/getFriend.scss';
</style>

